import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Duration } from '../../../components/FlightDetails/Duration.js';
import { Connector } from '../../../components/FlightDetails/Segment/components/Connector.js';
import { Container } from '../../../components/FlightDetails/Segment/components/Container.js';
import { Dot } from '../../../components/FlightDetails/Segment/components/Dot.js';
import { Item } from '../../../components/FlightDetails/Segment/components/Item.js';
import { Timeline } from '../../../components/FlightDetails/Segment/components/Timeline.js';
import { TextWrapper } from '../../../components/FlightDetails/TextWrapper.js';
import { Flex, LabelMediumBold, LabelXSmall, LabelXSmallBold } from '../../../primitives/index.js';
import { qaId } from '../../../utils/index.js';
import { FLIGHT_DETAILS_QA_ID } from '../../../utils/qaId.js';
export const Segment = ({
  departureTime,
  departureLocation,
  departureIata,
  arrivalTime,
  arrivalLocation,
  arrivalIata,
  duration,
  info,
  arrivalAlert,
  departureAlert,
  alert = false,
  highlightTime = false,
  highlightInfo = false,
  highlightIata = false
}) => {
  const {
    t
  } = useTranslation('flightDetails');
  return _jsxs(Container, {
    "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'flight-info'),
    children: [_jsxs(Timeline, {
      spacing: "none",
      children: [_jsx(Dot, {}), _jsx(Connector, {}), _jsx(Dot, {})]
    }), _jsxs(Flex, {
      spacing: "16px",
      children: [_jsxs(Item, {
        alert: alert,
        children: [_jsxs(Flex, {
          direction: "row",
          spacing: "8px",
          children: [_jsxs(Flex, {
            direction: "row",
            spacing: "2px",
            children: [_jsx(LabelMediumBold, {
              children: _jsx(TextWrapper, {
                highlighted: highlightTime,
                "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'departure-time'),
                children: departureTime
              })
            }), departureAlert > 0 && _jsx(LabelXSmallBold, {
              children: `+${departureAlert}
                  ${t('day', {
                count: departureAlert
              })}`
            }), ' ']
          }), _jsx(LabelMediumBold, {
            color: alert ? 'systemWarningAlert' : 'contentPrimary',
            "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'departure-location'),
            children: departureLocation
          })]
        }), _jsx(LabelXSmall, {
          color: alert ? 'systemWarningAlert' : 'contentSecondary',
          children: _jsx(TextWrapper, {
            highlighted: highlightIata,
            "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'departure-airport'),
            children: departureIata
          })
        })]
      }), _jsxs(Flex, {
        direction: "row",
        spacing: "8px",
        children: [!!duration && _jsx(Duration, {
          "data-testid": "shared-flightLayer-flightDuration",
          children: duration
        }), _jsx(LabelXSmall, {
          color: "contentSecondary",
          children: _jsx(TextWrapper, {
            highlighted: highlightInfo,
            "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'airLine'),
            children: info
          })
        })]
      }), _jsxs(Item, {
        alert: alert,
        children: [_jsxs(Flex, {
          direction: "row",
          spacing: "8px",
          children: [_jsxs(Flex, {
            direction: "row",
            spacing: "2px",
            children: [_jsx(LabelMediumBold, {
              children: _jsx(TextWrapper, {
                highlighted: highlightTime,
                "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'arrival-time'),
                children: arrivalTime
              })
            }), arrivalAlert > 0 && _jsx(LabelXSmallBold, {
              children: `+${arrivalAlert}
                  ${t('day', {
                count: arrivalAlert
              })}`
            }), ' ']
          }), _jsx(LabelMediumBold, {
            "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'arrival-location'),
            children: arrivalLocation
          })]
        }), _jsx(LabelXSmall, {
          color: "contentSecondary",
          "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'arrival-airport'),
          children: arrivalIata
        })]
      })]
    })]
  });
};